define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dojo/store/Memory",
    "underscore",
    "csi",
    "csi/config",
    "csi/def",
    "csi/def/Field",
    "csi/def/Relationship",
    "csi/form/Widget",
    "csi/locale",
    "csi/reflection",
    "csi/types",
    "csi/xml"
], function(declare,lang,Memory,_,csi,config,def,Field,Relationship,Widget,locale,reflection,types,xml) {

    var LOOKUP_ITEM_SUBTYPE = "LookupItemSubtype";
    var VALIDATION_EXPRESSION = "ValidationExpression";
    var VALIDATION_ERROR_MESSAGE = "ValidationErrorMessage";
    
    var TYPES = [
        xml.ATTR_BOOLEAN,
        xml.ATTR_DOUBLE,
        xml.ATTR_INTEGER,
        xml.ATTR_REF,
        xml.ATTR_REFLIST,
        xml.ATTR_STRING
        ];

    return declare(Widget, {
        /**
         * @property {string} _currentValueType
         * To capture the current valuetype to make sure to clear all value attribute fields
         */
        _currentValueType: null,

        /**
         * @override
         * Add Subtype attribute if not exist and other valueAttributeFields
         */
        _resolveView: function() {
            const subtypeField = this.getField(reflection.ATTR_SUBTYPE);
            if (!subtypeField) {
                var f = lang.mixin(new Field(), {
                    m_id: reflection.ATTR_SUBTYPE
                });
                this.insertField(f, 0);
            }

            if (!this.isCopy()) {
                var valueTypeField = lang.mixin(new Field(), {
                    m_id: reflection.ATTR_VALUETYPE,
                    m_typeControl: def.FIELD_FILTERING_SELECT
                });
                this.insertField(valueTypeField);

                var attrFormatField = lang.mixin(new Field(), {
                    m_id: reflection.ATTR_FORMAT,
                    m_typeControl: def.FIELD_FILTERING_SELECT
                });
                this.insertField(attrFormatField);

                var lookUpItemSubTypeField = lang.mixin(new Field(), {
                    m_id: LOOKUP_ITEM_SUBTYPE,
                    m_typeControl: def.FIELD_FILTERING_SELECT
                });
                this.insertField(lookUpItemSubTypeField);

                var validationExpnField = lang.mixin(new Field(), {
                    m_id: VALIDATION_EXPRESSION
                });
                this.insertField(validationExpnField);

                var validationErrorField = lang.mixin(new Field(), {
                    m_id: VALIDATION_ERROR_MESSAGE
                });
                this.insertField(validationErrorField);
            }

            this.inherited(arguments);
        },

        /**
         * @override
         * Show or hide Value Attributes based on Subtype Settings
         */
        _updateFieldVisibility: function(field) {
            this.inherited(arguments);
            var subtype = this.getFieldValue(reflection.ATTR_SUBTYPE);
            var selectedValueType = this.getFieldValue(reflection.ATTR_VALUETYPE);
            var bEnableValueAttrs = xml.isValidURL(subtype) && config.getSubtypeSetting(subtype, "EnableValueAttributes");
            var isBoolean = (selectedValueType == xml.ATTR_BOOLEAN);
            var isDoubleorInt = (selectedValueType == xml.ATTR_DOUBLE || selectedValueType == xml.ATTR_INTEGER);
            var isReforReflist = (selectedValueType == xml.ATTR_REF || selectedValueType == xml.ATTR_REFLIST);
            const isString = selectedValueType == xml.ATTR_STRING;
            this.setFieldRequired(LOOKUP_ITEM_SUBTYPE,false);

            if (!this.isCopy() && bEnableValueAttrs) {
                this._hideValueAttributeFields(false);
                if (selectedValueType != this._currentValueType){
                    if (this.isNew()) {
                       this._clearValueAttributeFields();
                    } else {
                       this._populateValueAttributeFields();
                    }
                }

                this._currentValueType = selectedValueType;

                if (isBoolean) {
                    this._disableValueAttributeFields(true);
                } else if (isDoubleorInt) {
                    this._disableValueAttributeFields(false);
                    this.setFieldDisabled(LOOKUP_ITEM_SUBTYPE, true);
                    var store = this.getFieldStore(reflection.ATTR_FORMAT);
                    this.setFieldStore(this.getField(reflection.ATTR_FORMAT), store);
                } else if (isReforReflist) {
                    this._disableValueAttributeFields(true);
                    this.setFieldDisabled(LOOKUP_ITEM_SUBTYPE, false);
                    this.setFieldRequired(LOOKUP_ITEM_SUBTYPE,true);
                } else {
                    if (isString && this.getFieldValue(reflection.ATTR_FORMAT) == "Rich") {
                        this.setFieldDisabled(reflection.ATTR_FORMAT, false);
                        this.setFieldDisabled(LOOKUP_ITEM_SUBTYPE, true);
                        this.setFieldDisabled(VALIDATION_EXPRESSION, true);
                        this.setFieldDisabled(VALIDATION_ERROR_MESSAGE, true);
                    } else {
                        this._disableValueAttributeFields(false);
                        this.setFieldDisabled(LOOKUP_ITEM_SUBTYPE, true);
                    }
                    this.resetFieldStoreAndValue(reflection.ATTR_VALUETYPE, xml.ATTR_STRING);
                    var store = this.getFieldStore(reflection.ATTR_FORMAT);
                    this.setFieldStore(this.getField(reflection.ATTR_FORMAT), store);
                    if (this.isEdit()){
                       this.setFieldDisabled(reflection.ATTR_FORMAT, true);
                    }
                }
            } else {
                this._hideValueAttributeFields(true);
            }
        },

        /**
         * Hide or show ValueAttributeFields
         * @param {boolean} bHide
         */
        _hideValueAttributeFields: function(bHide){
            this.setFieldHidden(reflection.ATTR_VALUETYPE, bHide);
            this.setFieldHidden(reflection.ATTR_FORMAT, bHide);
            this.setFieldHidden(LOOKUP_ITEM_SUBTYPE, bHide);
            this.setFieldHidden(VALIDATION_EXPRESSION, bHide);
            this.setFieldHidden(VALIDATION_ERROR_MESSAGE, bHide);
        },

        /**
         * clear all ValueAttributeFields
         */
        _clearValueAttributeFields: function(){
            this.setFieldValue(reflection.ATTR_FORMAT, "");
            this.setFieldValue(LOOKUP_ITEM_SUBTYPE, "");
            this.setFieldValue(VALIDATION_EXPRESSION, "");
            this.setFieldValue(VALIDATION_ERROR_MESSAGE, "");
        },

        /**
         * populate all ValueAttributeFields
         */
        _populateValueAttributeFields: function(){
            this.setFieldValue(reflection.ATTR_FORMAT, this.getFieldValue(reflection.ATTR_FORMAT));
            this.setFieldValue(LOOKUP_ITEM_SUBTYPE, this.getFieldValue(LOOKUP_ITEM_SUBTYPE));
            this.setFieldValue(VALIDATION_EXPRESSION, this.getFieldValue(VALIDATION_EXPRESSION));
            this.setFieldValue(VALIDATION_ERROR_MESSAGE, this.getFieldValue(VALIDATION_ERROR_MESSAGE));
        },

        /**
         * Disable or enable ValueAttributeFields
         * @param {boolean} bDisable
         */
        _disableValueAttributeFields: function(bDisable){
            this.setFieldDisabled(reflection.ATTR_FORMAT, bDisable);
            this.setFieldDisabled(LOOKUP_ITEM_SUBTYPE, bDisable);
            this.setFieldDisabled(VALIDATION_EXPRESSION, bDisable);
            this.setFieldDisabled(VALIDATION_ERROR_MESSAGE, bDisable);
        },

        /**
         * @override
         * Create store for format and valuetype
         */
        getFieldStore: function(field, value) {
            field = this.getField(field);
            var attrType = this.getFieldValue(reflection.ATTR_VALUETYPE);
            var name = field.getControlName();
            var data;

            if (name == reflection.ATTR_VALUETYPE) {
                data = _.map(TYPES, function(type) { return {name: locale.getAttributeType(type), id: type}; });
                return new Memory({data: data});
            } else if (name == reflection.ATTR_FORMAT) {
                // collect list of available formats based on selected value type
                data = _.map(types.getFormats(attrType) || [""], function(f) {
                    return {
                        id: f,
                        name: types.getLocalizedFormat(f)
                    };
                });

                if (attrType && !attrType.indexOf(xml.ATTR_STRING)) {
                    data = csi.sort(data, "name");
                }

                return new Memory({
                    data: data,
                    labelProperty: "name",
                    getEmptyValue: function() {
                        return this.data[0].id;
                    }
                });
            } else if (name == LOOKUP_ITEM_SUBTYPE){
                return config.getSubtypeStore("LookupItem");
            }
            return this.inherited(arguments);
        }
    });
});